module.exports = __webpack_public_path__ + "img/token.4bae780e.svg";